import { Component } from 'react';
import { ExamTimeTypes, ExamTime } from '../../Functions';

export default class ExamTimer extends Component {
	state = {
		// time: 10,
		time: this.props.time,
	};
    // time (seconds), 0 minimum & 3599 maximum to return a pure time
	time_to_string = (time) => {
		const min = Math.floor(time / 60);
		switch (true) {
			case min === 0:
				return time < 10 ? '00:0' + `${time}` : '00:' + `${time}`;
			case min < 60:
				return min < 10
					? `0${min}:${time % 60 < 10 ? '0' + `${time % 60}` : time % 60}`
					: `${min}:${time % 60 < 10 ? '0' + `${time % 60}` : time % 60}`;
			case time <= 0 || time >= 3600:
				return NaN;
			default:
				return NaN;
		}
	};
    encriptTime = (secends) => {
        // secends > 1 && localStorage.setItem('examTimeLeft', secends - 1);
		secends > 1 && localStorage.setItem('examTimeLeft', ExamTime(ExamTimeTypes.encrypt, secends - 1));
		// const encryptedTime = ExamTime(ExamTimeTypes.encrypt, secends);
		// const decryptedTime = ExamTime(ExamTimeTypes.decrypt, encryptedTime)
    }
    componentDidMount() {
        const timer = setInterval(() => {
            this.setState({time: this.state.time - 1}, () => {
                this.encriptTime(this.state.time)
            });
            if (this.state.time === 0) {
                clearInterval(timer);
                this.props.enable_lockMode();
            }
        }, 1000);
    }
	render() {
		return this.time_to_string(this.state.time);
	}
}